/**
 * Base class for django models
 */
export abstract class Model {
  id: number;
}
